import clsx from "clsx";

import type { ReactNode } from "react";

export default function ContentScroll({
  children,
  className,
}: {
  children: ReactNode;
  className: string;
}) {
  return (
    <div
      id="content-scroll"
      className={clsx(
        "flex overflow-y-auto overflow-x-hidden flex-col scrollbar-thin grow",
        className,
      )}
    >
      {children}
    </div>
  );
}
